import { forwardRef } from "react";
import Icon from "./Icon";

type Props = {
  id?: string;
  disabled?: boolean;
  onClick?: $TSFixMeFunction;
  icon: string;
  className?: string;
};

const IconButton = forwardRef<$TSFixMe, Props>(
  ({ id, icon, disabled, onClick, className }, ref) => (
    <button
      id={id}
      className={[className, "icon-button"].filter((c) => c).join(" ")}
      onClick={onClick}
      disabled={disabled}
      // eslint-disable-next-line react/button-has-type
      type="button"
      ref={ref}
    >
      <Icon name={icon} />
    </button>
  ),
);

IconButton.defaultProps = {
  id: undefined,
  disabled: false,
  onClick: undefined,
  className: undefined,
};

export default IconButton;
